import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Message } from '../../../../ngrx-message/models/client/message';
import { PlatformService } from '@panamax/app-state';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
})
export class MessageComponent {
  @Input() message: Message;

  constructor(
    private modalCtrl: ModalController,
    readonly platformService: PlatformService,
    private translateService: TranslateService,
  ) {}

  dismiss() {
    const msg = { ...this.message };
    msg.read = true;
    this.modalCtrl.dismiss(msg);
  }

  /**
   * Translates text that could be either a translation key or hardcoded text
   * If the text starts with 'i18n.', it's treated as a translation key
   * Otherwise, it's returned as-is (assuming it's hardcoded text)
   */
  translateText(text: string): string {
    if (!text) return text;

    if (text.startsWith('i18n.')) {
      return this.translateService.instant(text);
    }
    return text;
  }

  /**
   * Gets the translated title for the message
   * Priority: message.title (if exists) -> translated message.type -> fallback
   */
  getTranslatedTitle(): string {
    if (this.message?.title) {
      return this.translateText(this.message.title);
    }

    if (this.message?.type) {
      const typeTranslationKey = `i18n.message.types.${this.message.type}`;
      return this.translateService.instant(typeTranslationKey);
    }

    return '';
  }

  /**
   * Gets the translated display text for the message
   */
  getTranslatedDisplay(): string {
    if (!this.message?.display) return '';

    // Handle IonicSafeString by converting to string first
    const displayText =
      typeof this.message.display === 'string'
        ? this.message.display
        : this.message.display.toString();

    return this.translateText(displayText);
  }
}
